export default "/assets/document_el-155058a7617318981ba3a249eb384fb2d7ed120dc1853415d469977c5ddb0064.svg";